import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import ModalConfirm from "../modal-comfirm";
import { useState } from "react";
import { useTranslation } from "react-i18next";

type ButtonGobackProps = {
    onClick?: () => void;
    isConfirm?: boolean;
    confirmContent?: {
        title?: string;
        content?: string;
        titleComfirm?: string;
    };
};
const ButtonGoback = ({ onClick, isConfirm = false, confirmContent }: ButtonGobackProps) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [openModalConfirm, setOpenModalConfirm] = useState<boolean>(false);
    const handleGoback = () => {
        if (isConfirm) {
            setOpenModalConfirm(true);
        } else {
            navigate(-1);
        }
    };

    return (
        <div>
            <button
                className="btn shadow-sm text-sm font-medium bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200"
                type="button"
                onClick={onClick ? onClick : handleGoback}
            >
                <div className="flex items-center gap-2 text-gray-600">
                    <ArrowLeft size={16} /> {t("common.back")}
                </div>
            </button>
            {isConfirm && openModalConfirm && (
                <ModalConfirm
                    isOpen={openModalConfirm}
                    onClose={() => setOpenModalConfirm(false)}
                    title={confirmContent?.title || t("common.confirm")}
                    content={confirmContent?.content || t("common.backConfirm")}
                    titleComfirm={confirmContent?.titleComfirm || t("common.confirm")}
                    action={() => {
                        navigate(-1);
                        setOpenModalConfirm(false);
                    }}
                />
            )}
        </div>
    );
};

export default ButtonGoback;
